export class ExpiredLoginError extends Error {
    constructor(message, loginUrl) {
        super(message);
        this._loginUrl = "";
        this.loginUrl = loginUrl || "";
    }
    set loginUrl(url) {
        this._loginUrl = url;
    }
    get loginUrl() {
        return this._loginUrl;
    }
}
//# sourceMappingURL=exceptions.js.map